import {} from '@/components/ats';
import { KImage, KText } from '@/ui-library/components';
import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { components } from 'react-select';
import moment from 'moment-timezone';
import { SchInterviewerCalNotConnected } from '@/components/shared/interview-scheduler/SchedulerDetails/InterviewSchedulerForm/Fields/SchInterviewerField/SchInterviewerCalNotConnected';
import { SchInterviewerTimezoneNotSet } from '@/components/shared/interview-scheduler/SchedulerDetails/InterviewSchedulerForm/Fields/SchInterviewerField/SchInterviewerTimezoneNotSet';
import { TIME_ZONE_CONSTANTS } from '@/utils/timeZoneConstants';
import { AlertTriangle } from '@kula-ai/icons-core';

export const SchInterviewerMultiValueLabel = (props) => {
  const {
    interviewDataRef,
    data,
    registerForUpdates,
    variant,
    SELF_SCHEDULE_VARIANTS,
    onTimezoneClick,
  } = props;
  const { label, avatar, value, time_zone } = data || {};
  const { userCalendarInfo, bookedSlot, calendarOwnerUserId, calendar_info } =
    interviewDataRef?.current || {};
  const isUserCalendarConnected =
    userCalendarInfo?.[value]?.isCalendarConnected;
  const [, forceUpdate] = useState({});

  // Don't show warning if it's the user's primary calendar
  const isCalendarOwner =
    calendarOwnerUserId &&
    value === calendarOwnerUserId &&
    !calendar_info?.is_primary;

  // Check if timezone is missing
  const isTimeZoneNotAvailable = !time_zone;

  useEffect(() => {
    const unregisterUserCalendarInfo = registerForUpdates(
      'userCalendarInfo',
      () => {
        forceUpdate({});
      }
    );

    const unregisterBookedSlot = registerForUpdates('bookedSlot', () => {
      forceUpdate({});
    });

    const unregisterCalendarOwnerUserId = registerForUpdates(
      'calendarOwnerUserId',
      () => {
        forceUpdate({});
      }
    );

    return () => {
      unregisterUserCalendarInfo();
      unregisterBookedSlot();
      unregisterCalendarOwnerUserId();
    };
  }, [registerForUpdates]);

  const timeZone = time_zone; // || findTimeZone(moment.tz.guess())?.name;
  const { abbreviation } = TIME_ZONE_CONSTANTS?.[timeZone] || {};
  const slotTime = timeZone
    ? moment(bookedSlot?.start).tz(timeZone).format('hh:mm A')
    : '';

  const showCalendarNotConnected = isUserCalendarConnected === false;
  return (
    <components.MultiValueLabel {...props}>
      <Flex
        gap="4px"
        width="100%"
        overflow="hidden"
        alignItems="center"
        maxWidth="100%"
        position="relative"
        // border={showCalendarNotConnected && '1px solid'}
        // borderColor="secondary-700"
      >
        {isCalendarOwner && (
          <Tooltip
            shouldWrapChildren
            bg="secondary-950"
            borderRadius="6px"
            p="12px"
            label="As the Outlook calendar owner, this interviewer will not receive a meeting invite to join the interview. They'll receive a notification from Kula instead."
            placement="bottom"
            hasArrow
          >
            <AlertTriangle
              size={16}
              color="var(--kula-colors-warning-200)"
              className="kula-icon"
              style={{
                flexShrink: 0,
                position: 'relative',
                bottom: '1px',
                marginRight: '4px',
              }}
            />
          </Tooltip>
        )}
        {isTimeZoneNotAvailable &&
          !isCalendarOwner &&
          (variant === SELF_SCHEDULE_VARIANTS.SELF ||
            variant === SELF_SCHEDULE_VARIANTS.BULK_SELF) && (
            <SchInterviewerTimezoneNotSet
              onSetTimezone={() => onTimezoneClick?.()}
            />
          )}
        {showCalendarNotConnected && !isCalendarOwner && (
          <SchInterviewerCalNotConnected>
            {/* Commented out section remains unchanged */}
          </SchInterviewerCalNotConnected>
        )}
        <KImage src={avatar} name={label} size="16px" />
        <Flex
          gap="4px"
          alignItems="flex-end"
          flex={1}
          overflow="hidden"
          minWidth="0"
        >
          <KText
            variant="paragraph"
            size="sm-medium"
            minWidth={
              label.length || bookedSlot?.start > 30 ? 'unset' : 'fit-content'
            }
            isTruncated
            maxWidth="250px"
            flexShrink={1}
            fontWeight="450"
            color={isCalendarOwner ? 'pastel-6-dark' : 'secondary-700'}
          >
            {label}
          </KText>
          {bookedSlot?.start && time_zone && slotTime && (
            <Tooltip
              label={'Interview will happen at this time for this interviewer'}
            >
              <Box as="span" style={{ flexShrink: 0, margin: 1 }}>
                <KText
                  minWidth="fit-content"
                  flexShrink={0}
                  variant="small_text"
                  color={isCalendarOwner ? 'pastel-6-dark' : 'secondary-700'}
                >
                  {slotTime} {abbreviation ? `${abbreviation}` : ''}
                </KText>
              </Box>
            </Tooltip>
          )}
        </Flex>
      </Flex>
    </components.MultiValueLabel>
  );
};
